var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datamodel && _vm.datamodel.value)?_c('div',{staticClass:"img-item-content",style:(_vm.imgWidth)},[_c('img',{attrs:{"src":_vm.src,"alt":"","height":"200"}})]):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }